/**
 * TabulatorLifecyclePage - Tabulator lifecycle dashboard
 *
 * Surfaces the TabulatorLifecycleDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides advanced tabular data views with lifecycle state tracking.
 *
 * Route: /admin/tabulator-lifecycle
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconTable } from '@tabler/icons-react';

import { TabulatorLifecycleDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function TabulatorLifecyclePage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="cyan">
            <IconTable size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Tabulator Lifecycle</Title>
            <Text size="sm" c="dimmed">
              Advanced tabular data views with lifecycle state tracking
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <TabulatorLifecycleDashboard />
    </Container>
  );
}

export default TabulatorLifecyclePage;
